import { action, computed } from 'mobx';

import { ViewController } from '@estee/elc-service';

import { SignInType } from '~constants/SignInTypeEnum';
import { UserRepository } from '~repositories/UserRepository';
import { LoginSubmittedUseCase } from '~use-cases/LoginSubmittedUseCase';
import { MessageGroup, MessageRepository } from '~repositories/MessageRepository';

interface IGuestCheckoutFormViewController {
    userRepository: UserRepository;
    messageRepository: MessageRepository;
}

export class GuestCheckoutFormViewController extends ViewController {
    private userRepository: UserRepository;
    private messageRepository: MessageRepository;

    constructor({ userRepository, messageRepository }: IGuestCheckoutFormViewController) {
        super();
        this.userRepository = userRepository;
        this.messageRepository = messageRepository;
    }

    @computed
    public get data() {
        const errorMessages = this.messageRepository.messages.get(MessageGroup.GUEST_CHECKOUT);

        return {
            formStore: this.formStore,
            errorMessages
        };
    }

    @computed
    public get formStore() {
        const { guestSignInFormStore } = this.userRepository;

        return guestSignInFormStore;
    }

    @action
    public submitButtonClicked = async () => {
        const { validateForm, isValid, values } = this.formStore;
        validateForm();
        isValid &&
            (await new LoginSubmittedUseCase({
                signInData: values,
                signInType: SignInType.GUEST,
                formStore: this.formStore
            }).execute());
    };
}
